import axios from "axios";
const service = axios.create({
        baseURL: '',
        timeout: 5000,
        headers: {
            " App-Key": " $payeqqb1lwjxn3xg86l3",
            "App-Sign": "md5($1otw511d2uci7z52302tjwx18fjtmsco.POSTDATA)",
            "Content-Type": "application/json;charset=utf-8",
            
        },


    })
    // axios的拦截器(类似python的中间件的request)
service.interceptors.request.use(aaa => {
        // 多用于登录时的cookies判断
        return aaa
    }, err => {
  
    })
    // 数据返回拦截
service.interceptors.response.use(aaa => {
        // 多用于登录时的cookies判断
        return aaa.data
    }, err => {

    })
    // 直接返回

export default service


// WEBPACK FOOTER //
// ./src/utils/request.js